import request from '../plugins/request'
import api from '../config/api'
import qs from 'qs'

export default {
  getPushMessage (data) {
    return request.get(api.GETPUSHMESSAGE + '?' + qs.stringify(data))
  },
  getQuestionList (data) {
    return request.get(api.GETQUESTIONLIST + '?' + qs.stringify(data))
  }
  // getProducts (data) {
  //   return request.post(api.PRODUCTS, data)
  // },
  // // 订单支付页面信息接口
  // postPay (data) {
  //   return request.post(api.PAY_ORDER, data, { atom: true })
  // }
}



// WEBPACK FOOTER //
// ./src/services/index.js